// // Import necessary libraries
import * as React from 'react';
import { Avatar, Button, CssBaseline, TextField, Box, Typography, Container, Link, CircularProgress } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from '../../../interseptor/axiosConf';
import ToastrNotifi from '../../../Utilities/ToastrNotifi';
import { useLocation, useNavigate } from 'react-router-dom';

const theme = createTheme();

export default function Login() {
  const [resErrors, setResErrors] = React.useState({ email: "", password: "" });
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const location = useLocation();


  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const data = new FormData(event.currentTarget);
      setLoading(true);
      // Get form values
      const loginData = {
        email: data.get('email'),
        password: data.get('password'),
      };

      // Attempt login request
      const response = await axios.post('/api/user/login', loginData);

      // Check for success response
      if (response.data.success) {
        ToastrNotifi.successToast("Login Success!");
        setResErrors({});
        setLoading(false);
        // Redirect to dashboard
        navigate('/');
      } else if (response.data.errors) {
        const errorMessages = Object.values(response.data.errors).flat();
        errorMessages.forEach(message => ToastrNotifi.warningToast(message));
        setLoading(false);

      } else {
        ToastrNotifi.errorToast("Unexpected response format. Please try again.");
        console.warn("Unexpected response structure:", response.data);
        setLoading(false);
      }

    } catch (error) {
      // Advanced error handling
      setLoading(false);
      if (error.response) {
        // Server-side error response
        if (error.response.status === 402) {
          ToastrNotifi.warningToast("Invalid credentials. Please check your email and password.");

        } else if (error.response.status >= 500) {
          ToastrNotifi.errorToast("Server error. Please try again later.");
        } else if (error.response.data && error.response.data.errors) {

          setResErrors(error.response.data.errors);

          const errorMessages = Object.values(error.response.data.errors).flat();
          errorMessages.forEach(message => ToastrNotifi.warningToast(message));
        } else {
          ToastrNotifi.errorToast("An error occurred. Please try again.");
        }
      } else if (error.request) {
        // No response from the server
        ToastrNotifi.errorToast("Network error. Please check your connection.");
        console.error("No response received:", error.request);
      } else {
        // Error in setting up the request
        ToastrNotifi.errorToast("Request error. Please contact support.");
        console.error("Error setting up request:", error.message);
      }
    }

  };

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const message = searchParams.get('message');

    if (message === 'session_expired') {
      ToastrNotifi.infoToast('Your session has expired. Please log in.');
    }
    if (message === 'validation_error') {
      ToastrNotifi.warningToast('Validation failed. Please log in');

    }
  }, [location]);

  return (
    <>
      <div className='container'>
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  error={!!resErrors.email}
                  helperText={resErrors.email ? resErrors.email[0] : ""}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  error={!!resErrors.password}
                  helperText={resErrors.password ? resErrors.password[0] : ""}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading ? (
                    <CircularProgress size="24px" color="inherit" />  // Spinner size/color customization
                  ) : (
                    'Sign In'
                  )}
                </Button>

              </Box>
            </Box>
          </Container>
        </ThemeProvider>
      </div>
    </>
  );
}
